import { install, getEventEmitter } from '@tcc/farmer-navigation';

/**
 * Expose the nav event emitter values to the app props
 * @return {Promise}
 */
export default function setup() {
  install(document.querySelector('#nav'));
  return Promise.resolve({ nav: { emitter: getEventEmitter() }});
}
